import KAutocomplete from "./KAutocomplete";
import {
	VIcon,
	VListItem,
	VListItemAvatar,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle
} from "vuetify/lib";
import { debounce } from "kinnect-helpers";
import { formatGooglePlaceData } from "kinnect-formatters";
import { gmapApi } from "vue2-google-maps";

export default {
	name: "KGooglePlacesTextSearch",

	extends: KAutocomplete,

	props: {
		cacheItems: {
			default: true,
			type: Boolean
		},

		hideNoData: {
			default: true,
			type: Boolean
		}
	},

	data: () => ( {
		searching: false,
		placesService: null,
		results: [],
		search: null
	} ),

	computed: {
		google: gmapApi,

		searchItems() {
			return this.results.map( result => {
				result.searchText = `${result.name} (${result.formatted_address})`;

				return result;
			} );
		}
	},

	watch: {
		search( val ) {
			this.textSearch( val );
		}
	},

	methods: {
		update( val ) {
			this.$emit( "input", val );
		},

		textSearch: debounce( function( val ) {
			if ( val ) {
				this.searching = true;

				this.placesService.textSearch( {
					query: val,

					bounds: new this.google.maps.LatLngBounds(
						new this.google.maps.LatLng( 34.521833, -100.008545 ),
						new this.google.maps.LatLng( 36.929586, -94.603271 )
					)
				}, ( results, status ) => {
					if ( val === this.search ) {
						this.results = ( status === this.google.maps.places.PlacesServiceStatus.OK ) ? results : [];
					}

					this.searching = false;
				} );
			}
		}, 300 ),

		genSearchHighlight( text, genHighlightFn ) {
			const regex = new RegExp( this.search || "", "ig" );

			return text.toString().replace( regex, matchedText => genHighlightFn( matchedText ) );
		},

		setupGoogle() {
			this.placesService = new this.google.maps.places.PlacesService( document.createElement( "div" ) );
		}
	},

	mounted() {
		this.$gmapApiPromiseLazy().then( this.setupGoogle );
	},

	render() {
		return <KAutocomplete
			attrs={{
				...this.$props,
				items: this.searchItems,
				loading: this.searching
			}}
			itemText="searchText"
			itemValue="place_id"
			on={{
				...this.$listeners,
				"update:search-input": val => this.search = val
			}}
			searchInput={this.search}
			vModel={this.internalValue}
			scopedSlots={{
				item: ( { attrs, item, on, parent } ) =>
					<VListItem
						key={item.place_id}
						attrs={attrs}
						on={{
							...on,
							click: () => {
								if ( typeof on.click === "function" ) {
									on.click();
								}

								this.$emit(
									"placechanged",
									formatGooglePlaceData( item )
								);
							}
						}}
					>
						<VListItemAvatar>
							<VIcon>place</VIcon>
						</VListItemAvatar>

						<VListItemContent>
							<VListItemTitle
								domPropsInnerHTML={this.genSearchHighlight(
									item.name,
									parent.genHighlight
								)}
							></VListItemTitle>

							<VListItemSubtitle
								domPropsInnerHTML={this.genSearchHighlight(
									item.formatted_address,
									parent.genHighlight
								)}
							></VListItemSubtitle>
						</VListItemContent>
					</VListItem>
			}}
		></KAutocomplete>;
	}
};
